module.exports = __webpack_public_path__ + "static/sb_patching-ba134bfc64cb76cb111c18a6fa76ae68.mp4";